import { defineMessages } from 'react-intl';

import {
  ACHIEVEMENT_TYPES,
  QUEST_STATUSES,
  type QuestAchievementType,
} from '@didaskill/domain/user-achievements/constants';

export const questTitleMessages = defineMessages<QuestAchievementType>({
  [ACHIEVEMENT_TYPES.CAMPUS_EXPLORER]: {
    defaultMessage: 'Explorateur du campus',
  },
  [ACHIEVEMENT_TYPES.GAIN_CONFIDENCE]: {
    defaultMessage: 'Gagner en confiance',
  },
  [ACHIEVEMENT_TYPES.GOOD_HABITS]: {
    defaultMessage: 'Adopter de bonnes habitudes',
  },
  [ACHIEVEMENT_TYPES.SNAP_FINGERS]: {
    defaultMessage: 'Claquer des doigts',
  },
} as const);

export const questSubtitleMessages = defineMessages<QUEST_STATUSES>({
  [QUEST_STATUSES.LOCKED]: {
    defaultMessage: 'Disponible dans {count} {count, plural, one {jour} other {jours}}',
  },
  [QUEST_STATUSES.COMPLETED]: {
    defaultMessage: 'Terminé le {date}',
  },
  [QUEST_STATUSES.IN_PROGRESS]: {
    defaultMessage: 'Termine dans {count} {count, plural, one {jour} other {jours}}',
  },
} as const);
